import pLimit from "p-limit";

export function runWithConcurrency<T>(
  items: T[],
  limit: number,
  worker: (item: T) => Promise<void>
): Promise<void> {
  const limiter = pLimit(limit);
  return Promise.all(items.map((item) => limiter(() => worker(item)))).then(() => undefined);
}
